import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { I18NextModule } from 'angular-i18next';
import { AumicoComponentsModule } from '../../../../../../aumico-components/src/lib';
import { AumicoLayoutModule2 } from '../../../../../../aumico-layout/src/lib';
import { AumicoCoreModule } from '../../../../../../aumico-lib-core-fe/src/lib';
import { UsersModule } from '../../../../../../aumico-lib-users-fe/src/public-api';
import { FinancialClosingProcessAdapter } from './adapters/inbound/fcp.adapter';
import { DeleteChecklistModalComponent } from './components/delete-checklist-modal/delete-checklist-modal.component';
import { FcpCardComponent } from './components/fcpCard/fcpCard.component';
import { AnnualreportChecklistComponent } from './components/fcpChecklist/annualreport-checklist/annualreport-checklist.component';
import { FcpChecklistComponent } from './components/fcpChecklist/fcpChecklist.component';
import { ImportChecklistModal } from './components/fcpChecklist/import-checklist-modal/import-checklist-modal.component';
import { FcpClosingEntriesComponent } from './components/fcpClosingEntries/fcpClosingEntries.component';
import { FcpCommentsComponent } from './components/fcpComments/fcpComments.component';
import { FcpDocumentsComponent } from './components/fcpDocuments/fcpDocuments.component';
import { FinancialClosingProcessFormComponent } from './components/fcpForm.component';
import { FinancialClosingProcessPrintPreviewComponent } from './components/fcpPrintPreview.component';
import { FcpBundleItemComponent } from './components/fcpTree/fcpBundleItem.component';
import { FcpTestGroupItemComponent } from './components/fcpTree/fcpTestGroupItem.component';
import { FcpTestItemComponent } from './components/fcpTree/fcpTestItem.component';
import { FcpTreeComponent } from './components/fcpTree/fcpTree.component';
import { NoContentComponent } from './components/no-content/no-content.component';

import { FileTypeImageDirective } from './domain/directive/file-type-image.directive';
import { FcpEffects } from './domain/reducers/fcp.effects';
import { FcpFeature } from './domain/reducers/fcp.reducer';
import { FinancialClosingProcessPage } from './financialClosingProcess.page';
import { MarkAllAsDoneComponent } from './mark-all-as-done/mark-all-as-done.component';
import { GetTextForAccountPipe } from './pipe/getTextForAccount.pipe';

@NgModule({
    declarations: [
        FinancialClosingProcessPage,
        FinancialClosingProcessAdapter,
        FinancialClosingProcessFormComponent,
        FinancialClosingProcessPrintPreviewComponent,
        FcpTreeComponent,
        FcpBundleItemComponent,
        FcpTestGroupItemComponent,
        FcpTestItemComponent,
        FcpCommentsComponent,
        FcpChecklistComponent,
        FcpClosingEntriesComponent,
        FcpDocumentsComponent,
        FcpCardComponent,
        NoContentComponent,
        ImportChecklistModal,
        GetTextForAccountPipe,
        MarkAllAsDoneComponent,
        DeleteChecklistModalComponent,
        AnnualreportChecklistComponent,
        FileTypeImageDirective,
    ],
    imports: [
        CommonModule,
        I18NextModule,
        ReactiveFormsModule,
        MatProgressSpinnerModule,
        AumicoLayoutModule2,
        AumicoComponentsModule,
        AumicoCoreModule,
        StoreModule.forFeature(FcpFeature.name, FcpFeature.reducer),
        EffectsModule.forFeature([FcpEffects]),
        UsersModule,
        MatCheckboxModule,
        MatIconModule,
        MatDialogModule,
        MatTableModule,
    ],
    exports: [
        FinancialClosingProcessPage,
        FinancialClosingProcessAdapter,
        FinancialClosingProcessFormComponent,
        FinancialClosingProcessPrintPreviewComponent,
        FcpTreeComponent,
        FcpBundleItemComponent,
        FcpTestGroupItemComponent,
        FcpTestItemComponent,
    ],
})
export class FinancialClosingProcessModule { }
